module.exports = __webpack_public_path__ + "static/media/downloadBig.b5681a60.svg";